export default __webpack_public_path__ + "static/media/number with campaign.207f4f0f.svg";